<form [formGroup]="infoRenouvellementForm" class="form-container" (ngSubmit)="onSubmit()">
  <fieldset class="form-fieldset">
    <legend class="custom-legend">Informations sur le renouvellement</legend>

    <div class="radio-container">
      <label for="motif" class="label col-6 col-form-label">Motif *</label>
      <div class="form-text mb-1">Choisissez les motifs</div>
      <div class="radio-section">
        <mat-radio-group formControlName="motif">
          <div class="radio-row">
            <div class="radio-column">
              @if (!isMotifDisabled('contratMemePoste')) {
                <mat-radio-button value="contratMemePoste" color="primary" id="contratMemePoste">
                  <div class="break-line">
                    Renouvellement du contrat sur le même poste et dans les mêmes conditions (taux d'emploi, durée du contrat, rémunération et
                    affectation inchangés)
                  </div>
                </mat-radio-button>
              }
              @if (
                infoRenouvellementForm.get('contratMemePoste')?.hasError('required') &&
                infoRenouvellementForm.get('contratMemePoste')?.touched
                ) {
                <mat-error
                  >
                  Cette option est obligatoire si aucune autre case n'est cochée.
                </mat-error>
              }
              <mat-radio-button value="contratConditionsDiffs" color="primary" id="contratConditionsDiffs">
                <div class="break-line">
                  Renouvellement du contrat dans des conditions différentes : taux d'emploi, changement de poste, modification du contrat ou
                  de la rémunération (contacter obligatoirement la DRH et motiver la demande dans l'espace dédié)
                </div>
              </mat-radio-button>
              @if (
                infoRenouvellementForm.get('contratConditionsDiffs')?.hasError('required') &&
                infoRenouvellementForm.get('contratConditionsDiffs')?.touched
                ) {
                <mat-error
                  >
                  Cette option est obligatoire si aucune autre case n'est cochée.
                </mat-error>
              }
            </div>
            <div class="radio-column">
              <mat-radio-button value="refusContratDemande" color="primary" id="refusContratDemande">
                <div class="break-line">Refus de renouvellement du contrat demandé par la hiérarchie</div>
              </mat-radio-button>
              @if (
                infoRenouvellementForm.get('refusContratDemande')?.hasError('required') &&
                infoRenouvellementForm.get('refusContratDemande')?.touched
                ) {
                <mat-error
                  >
                  Cette option est obligatoire si aucune autre case n'est cochée.
                </mat-error>
              }
              <!-- Confirmation checkbox for refus -->
              @if (showRefusConfirmation) {
                <div class="confirmation-section">
                  <mat-checkbox formControlName="confirmRefus" color="primary">
                    La Direction s'engage à prévenir en amont l'agent de son non renouvellement *
                  </mat-checkbox>
                  @if (infoRenouvellementForm.get('confirmRefus')?.invalid && infoRenouvellementForm.get('confirmRefus')?.touched) {
                    <mat-error
                      >
                      Veuillez confirmer le refus de renouvellement.
                    </mat-error>
                  }
                </div>
              }
              <mat-radio-button value="refusContratConditions" color="primary" id="refusContratConditions">
                <div class="break-line">
                  Refus de renouvellement du contrat à l'initiative de l'agent (joindre obligatoirement la demande écrite de l'agent)
                </div>
              </mat-radio-button>
              @if (
                infoRenouvellementForm.get('refusContratConditions')?.hasError('required') &&
                infoRenouvellementForm.get('refusContratConditions')?.touched
                ) {
                <mat-error
                  >
                  Cette option est obligatoire si aucune autre case n'est cochée.
                </mat-error>
              }
            </div>
          </div>
        </mat-radio-group>
      </div>
      @if (infoRenouvellementForm.get('motif')?.invalid && infoRenouvellementForm.get('motif')?.touched) {
        <mat-error>
          Veuillez sélectionner un motif.
        </mat-error>
      }

      <mat-divider></mat-divider>
      <div class="table-container mt-3">
        <table class="mat-table mt-1 mb-4">
          <thead>
            <tr>
              <th>Cdisation</th>
              <th>Date Cdisation possible</th>
              <th>Nb. de jours avant cdisation</th>
              <th>Abs (année glissante)</th>
              <th>Nb. SNF (année glissante)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span
                  class="cdisation-badge"
                  [class.cdisation-oui]="cdisationData.flagCdisation"
                  [class.cdisation-non]="!cdisationData.flagCdisation"
                  >
                  {{ cdisationData.flagCdisation ? 'OUI' : 'NON' }}
                </span>
              </td>
              <td>{{ cdisationData.dateFinContrat | date: 'dd/MM/yyyy' }}</td>
              <td [style.color]="'#ffa500'">{{ cdisationData.nbJoursAvantCdisation }}</td>
              <td>{{ cdisationData.absenceDateDebut | date: 'dd/MM/yyyy' }} - {{ cdisationData.absenceDateFin | date: 'dd/MM/yyyy' }}</td>
              <td>{{ cdisationData.snfDateDebut | date: 'dd/MM/yyyy' }} - {{ cdisationData.snfDateFin | date: 'dd/MM/yyyy' }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mat-table mt-3">
          <thead>
            <tr>
              <th>Absence MO</th>
              <th>Absence AT/MP</th>
              <th>Absence MD/ML</th>
              <th>Absence MA/PA</th>
              <th>TOTAL (Nb. de jours d'absences)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ cdisationData.absenceMO }}</td>
              <td>{{ cdisationData.absenceATMP }}</td>
              <td>{{ cdisationData.absenceMDML }}</td>
              <td>{{ cdisationData.absenceMAPA }}</td>
              <td style="font-weight: 600">{{ cdisationData.totalJoursAbsences }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-divider class="divider"></mat-divider>
      <div class="attention-section">
        <p>
          <b>Attention :</b> Dans tous les cas, vous devez établir <b>obligatoirement</b> un rapport détaillé sur la manière de servir de
          l'agent et sur les motifs justifiant la prolongation et/ou la modification du contrat précédent ou le non-renouvellement. Dans le
          cas contraire, la demande de renouvellement de l'engagement ne sera pas prise en compte.
        </p>
      </div>
    </div>
  </fieldset>

  <!-- btns -->
  <div class="button-group">
    <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
    <button mat-stroked-button type="button" matStepperPrevious><mat-icon>undo</mat-icon>Précédent</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="!infoRenouvellementForm.valid" matStepperNext>Suivant</button>
  </div>
</form>
